import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Panel } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../../actions/entries';
import * as nationsActionCreators from '../../actions/nations';
import { EntryList, EntryFilter } from '../../components/entry';
import { competitions } from '../../constants/values';

const mapStateToProps = state => ({
  entries: state.entries.entries,
  nations: state.nations.nations,
  isLoggedIn: state.auth.isLoggedIn,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch),
  nationsActions: bindActionCreators(nationsActionCreators, dispatch),
});

class PublicEntryPage extends Component {
  static propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
    nations: PropTypes.array.isRequired,
    entries: PropTypes.array.isRequired,
    actions: PropTypes.object.isRequired,
    nationsActions: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      filters: {
        competition: competitions[0].value,
      },
    };
  }

  componentWillMount() {
    const { filters } = this.state;

    this.fetchData(filters);
  }

  fetchData(filters) {
    const { actions, nationsActions } = this.props;

    actions.fetchEntries(undefined, { filters });

    nationsActions.fetchNations();
  }

  changeFilter = (filterName, filterValue) => {
    const { filters } = this.state;

    const value = filterName === 'nation' && filterValue === 'ADMIN' ? undefined : filterValue;

    filters[filterName] = value;

    this.setState({ filters });

    this.fetchData(filters);
  };

  render() {
    const { entries, nations, isLoggedIn } = this.props;
    const { filters } = this.state;

    return (
      <div>
        {!isLoggedIn && process.env.REACT_APP_CVI !== 'Bern' && (
          <h1 style={{ marginBottom: 40, marginTop: 25 }}>
            Welcome to the entry system of the CVI {window.cviConfig.cviCity},{' '}
            {window.cviConfig.cviCountry}
          </h1>
        )}

        {!isLoggedIn && process.env.REACT_APP_CVI === 'Bern' && (
          <h1 style={{ marginBottom: 40, marginTop: 25 }}>
            Welcome to the entry system of FEI World Championships for Seniors and FEI European Championships for Juniors & Young Vaulters, Bern (SUI) 2024.
          </h1>
        )}

        {!isLoggedIn && (
          <Panel header="Event Information" bsStyle="primary">
            <p>
              <strong>Date of event:</strong> {window.cviConfig.eventDate}
            </p>
            <p>
              <strong>Place of event:</strong> {window.cviConfig.eventPlace}
            </p>
            <p>
              If you are a NF and do not have an access to this entry system or need any help please contact{' '}
              <a href={`mailto:${window.cviConfig.supportEmail}`}>{window.cviConfig.supportEmail}</a>
            </p>
          </Panel>
        )}
        
        {isLoggedIn && ( <h3 style={{ marginTop: 35 }}>{isLoggedIn ? 'All Entries' : 'Entries'}</h3> )}

        {isLoggedIn && (
          <EntryFilter
            filters={filters}
            onChangedFilter={this.changeFilter}
            registeredNations={nations}
          />
        )}
        
        {isLoggedIn && (
          <EntryList competition={filters.competition} entries={entries} isPublic />
        )}

        {!isLoggedIn && (
          <p>In order to view the entries for this championship you need to be logged in.</p>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PublicEntryPage)


// WEBPACK FOOTER //
// ./src/components/entry/PublicEntryPage.js